<template>
  <div :class="cssClasses">
    <div class="eventInformation">
      <v-container class="pt-0">
        <v-layout row wrap>
          <v-flex sm7 class="information mt-4">
            <h3
              v-html="
                extract('event.content.body.title') || extract('event.name')
              "
            ></h3>
            <div
              class="event-description"
              v-html="extract('event.content.body.description')"
            ></div>
            <table
              class="event-sections"
              v-if="extract('event.content.body.sections')"
            >
              <tr
                v-for="(obj, num) in extract('event.content.body.sections')"
                v-bind:key="num"
              >
                <td class="rowLabel">
                  <h4 class="section-title">
                    {{
                      extract("event.content.body.sections." + num + ".title")
                    }}:
                  </h4>
                </td>
                <td
                  v-html="
                    extract('event.content.body.sections.' + num + '.html')
                  "
                ></td>
              </tr>
            </table>
            <div
              class="event-closing"
              v-if="extract('event.content.body.closing')"
              v-html="extract('event.content.body.closing')"
            ></div>
            <div>
              <span
                class="capacity-notice"
                v-if="!loading && availableSlots < 1"
                >The event is currently at capacity, but sign up below to be
                added to the wait list and we'll email you if a spot opens
                up.</span
              >
            </div>
          </v-flex>
          <v-flex sm4 offset-sm1 class="callout">
            <!-- IF DEFAULT ASIDE -->
            <div class="whiteBox pa-4 mb-4 hidden-xs-only" v-if="hasAside">
              <div v-if="hasAside">
                <div v-if="defaultAside">
                  <!-- <p><img src="@/assets/es/Summit_SideCallout.svg" style='max-height: 200px; max-width:100%' /></p> -->
                  <p><v-img src="@/assets/es/Summit_01@2x.jpg" /></p>
                  <p><v-img src="@/assets/es/Summit_02@2x.jpg" /></p>
                </div>
                <div v-else class="customAside">
                  <AmazeDynamicComponent
                    v-bind:template="extract('event.content.aside.html')"
                  ></AmazeDynamicComponent>
                </div>
              </div>
            </div>
            <!-- END DEFAULT ASIDE -->
            <div id="refund-dialog">
              <v-dialog v-model="dialog" max-width="500px">
                <v-btn
                  slot="activator"
                  color="primary"
                  style="display: none"
                  id="refund-dialog-button"
                  class="mb-4 mt-4 ml-0"
                >
                  Learn more about RTI's refund and cancellation policy
                </v-btn>
                <v-card>
                  <v-card-title>
                    <h3 class="headline">Refund and Cancellation Policy</h3>
                  </v-card-title>
                  <hr class="thick" />

                  <v-card-text>
                    <v-layout wrap>
                      <div class="pa-2 mb-2">
                        <p>
                          The {{ event.name }} Cancellation and Refund Policy
                          will be as follows to assure consistency and is
                          applicable to this event.
                        </p>
                        <p>
                          {{ event.name }} registration canceled online on or
                          before {{ getFormattedDate(event.refund_expiry) }} is
                          refundable if already paid, or not due if not already
                          paid. In order for your cancellation to be received,
                          email
                          <a href="mailto:educationservices@rti.org ">
                            educationservices@rti.org</a
                          >
                          no later than
                          {{ getFormattedDate(event.refund_expiry) }}.
                        </p>
                      </div>
                    </v-layout>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" flat @click="dialog = false"
                      >Cancel</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <!-- END THE FORMATIONING -->
  </div>
</template>
<style scoped lang="scss">
.eventInformation {
  min-height: 80vh;
}
</style>
<script>
import registrationMixin from "@/mixins/registrationMixin.js";

export default {
  mixins: [registrationMixin],
  data() {
    return {
      dialog: false,
      loading: true,
      valid: false,
      submitted: false,
      acknowledge: false,

      availableSlots: 0,
      maxRegistrants: 0,
      totalAttendees: 0,

      schoolName: "",
      districtName: "",
      stateName: "",

      roles: ["Principal", "Teacher", "Counselor", "College Liaison", "Other"],

      registrants: 0,
      numRegistrants: 0,
      registrant: [],
      submittedSuccessfully: false,
      rules: {
        name: [(v) => !!v || "Name is required."],
        email: [
          (v) => !!v || "Email is required.",
          (v) => /@/.test(v) || "Please enter a valid email."
        ],
        role: [(v) => !!v || "Role is required."],
        school: [(v) => !!v || "School name is required."],
        district: [(v) => !!v || "District name is required."],
        state: [(v) => !!v || "State is required."],
        size: [(v) => !!v || "Team size is required."],
        acknowledge: [(v) => !!v || "Please accept the terms and conditions."]
      },
      event: {}
    };
  },
  computed: {
    terms() {
      return this.extract("event.content.terms", false);
    },
    acknowledgement() {
      return this.extract("event.content.acknowledgement", false);
    },
    content() {
      // var defaults = {};
      return event.content ? event.content : false;
    },
    id() {
      return this.extract("event.id");
    },
    hasAside() {
      var aside = this.extract("event.content.aside.custom");
      return aside !== null && typeof aside !== "undefined";
    },
    defaultAside() {
      return (
        !this.extract("event.content.aside.custom") ||
        !this.extract("event.content.aside.html")
      );
    },
    contactAddress() {
      return process.env.VUE_APP_CONTACT_ADDRESS;
    },
    loaded() {
      return !this.loading;
    }
  },

  mounted() {
    this.$http
      .get(
        "event/" +
          (this.$route.params.slug || this.$route.path.split("/").pop())
      )
      .then(
        (response) => {
          this.event = response.data.data[0];

          this.totalAttendees = this.extract("event.total_attendees") || 0;
          this.maxAttendees = this.extract("event.max_attendees") || 0;

          this.availableSlots = Math.max(
            0,
            this.maxAttendees - this.totalAttendees
          );

          this.maxRegistrants = this.extract("event.max_per_team");
          // If we need to limit registration to only accept the max number of slots, we can use the following logic:
          // Math.min(this.extract('event.max_per_team'), (this.maxAttendees - this.totalAttendees));

          var roles = this.extract("event.content.form.roles");

          if (roles && roles.length > 0) {
            this.roles = roles;
          }

          var fields = this.extract("event.content.form.fields");

          if (fields) {
            for (const key in fields) {
              var field = fields[key];
              // Set defaults.
              if (field.hasOwnProperty("default")) {
                this.$set(this, key, field.default);
              }
              // Set values.
              if (field.hasOwnProperty("values")) {
                this.$set(this, key, field.values);
              }
            }
          }

          if (this.maxRegistrants === 1) {
            // Single registration, set-up initial object to avoid null object errors.
            this.registrant.push({ name: "", email: null, role: null });
            this.registrants = 1;
          }

          this.loading = false;
          // eslint-disable-next-line handle-callback-err
        },
        (error) => {
          this.$router.push("/404");
        }
      );
  }
};
</script>
